import { render, staticRenderFns } from "./ForestProfile.vue?vue&type=template&id=e4f526a0&"
import script from "./ForestProfile.vue?vue&type=script&lang=js&"
export * from "./ForestProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports